<div class="app-wrapper"
     data-testid="construction-manager-overview">
  <div class="app-scrollable-content"
       data-testid="cm-container-scrollable-content">
    <router-outlet></router-outlet>
  </div>
  <app-footer-navigation-bar data-testid="cm-tab-footer-nav"
                             [menuItems]="tabs"
                             [defaultItem]="selectedTab"
                             (tabChanged)="onTabChanged($event)">
  </app-footer-navigation-bar>
</div>